/*
 * Masque le widget d'avis Klaviyo (.klaviyo-star-rating-widget) tant qu'il
 * n'y a aucun avis, l'affiche des qu'il y en a au moins un.
 *
 * Le widget est injecte / mis a jour de facon asynchrone par l'app Klaviyo.
 * On observe le DOM et on pose / retire la classe .kl-has-reviews sur le
 * widget. Le CSS de la section fait le reste (avec !important pour battre le
 * style inline `display: block` pose par l'app).
 *
 * Detection du nombre d'avis :
 *   1. label texte  ".kl_reviews__star_rating_widget__label"  -> "0 avis" / "12 avis"
 *   2. aria-label du bouton  -> "0 etoiles, 0 evaluations"
 */
(function () {
  var SELECTOR = '.klaviyo-star-rating-widget';

  function toInt(str) {
    var n = parseInt(String(str).replace(/\D/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  function reviewCount(widget) {
    // 1) label texte du widget
    var lbl = widget.querySelector('.kl_reviews__star_rating_widget__label');
    if (lbl && /\d/.test(lbl.textContent || '')) {
      return toInt(lbl.textContent);
    }

    // 2) aria-label du bouton : on isole le nombre colle au mot "avis/evaluation/review"
    var btn = widget.querySelector('[aria-label]');
    if (btn) {
      var label = btn.getAttribute('aria-label') || '';
      var m = label.match(/([\d][\d\s]*)\s*(?:evaluation|évaluation|avis|review|rating|note|opinion)/i);
      if (m) return toInt(m[1]);
    }

    // 3) fallback : nombre entre parentheses
    var m2 = (widget.textContent || '').match(/\(([\d][\d\s]*)\)/);
    if (m2) return toInt(m2[1]);

    return null;
  }

  function evaluate(widget) {
    var count = reviewCount(widget);
    // count === null : widget pas encore rendu -> on ne touche a rien (reste masque)
    if (count !== null) {
      widget.classList.toggle('kl-has-reviews', count > 0);
    }
  }

  function evaluateAll() {
    document.querySelectorAll(SELECTOR).forEach(evaluate);
  }

  function init() {
    evaluateAll();

    var observer = new MutationObserver(evaluateAll);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'class', 'style'],
    });

    // Filet de securite : re-eval periodique pendant ~10s puis arret.
    var ticks = 0;
    var timer = setInterval(function () {
      evaluateAll();
      if (++ticks >= 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
